// extracted by mini-css-extract-plugin
module.exports = {"root":"ClickToCloseWrapper__root--2XLIO"};